export const ESTABLISHMENT_ORIGIN_LEGEND = {
    OWN: 'Propio',
    THIRD_PARTY: 'Tercero'
} as const;

export const ESTABLISHMENT_ORIGIN_LEGEND_CONFIG = [
    { name: ESTABLISHMENT_ORIGIN_LEGEND.OWN, color: '#16A34A' },
    { name: ESTABLISHMENT_ORIGIN_LEGEND.THIRD_PARTY, color: '#EAB308' }
];

export const resolveEstablishmentOriginLegendName = (item: any): string => {
    const value = item?.propio;

    return value === true || value === 1 || value === '1' || value === 'true'
        ? ESTABLISHMENT_ORIGIN_LEGEND.OWN
        : ESTABLISHMENT_ORIGIN_LEGEND.THIRD_PARTY;
};

// A diferencia de la leyenda del listado, la condicion que se muestra como dato
// no asume Tercero cuando el establecimiento no la tiene cargada: devuelve null.
export const resolveEstablishmentCondition = (item: any): string | null => {
    const value = item?.propio;

    if (value === true || value === 1 || value === '1' || value === 'true') {
        return ESTABLISHMENT_ORIGIN_LEGEND.OWN;
    }
    if (value === false || value === 0 || value === '0' || value === 'false') {
        return ESTABLISHMENT_ORIGIN_LEGEND.THIRD_PARTY;
    }
    return null;
};
